import { type ISummaryItem } from "../../../../pages/Summary/Summary.types";

export const getVerifyFromSummary = (summaryItem: ISummaryItem) => ({
  id: summaryItem.partid ?? summaryItem.meid ?? summaryItem.lbeid,
  idType: summaryItem.partid ? "partid" : summaryItem.meid ? "meid" : "lbeid",
});
